import { appendParam } from "./genericUtils";

export const useAddFields = (base_url, filterChange, resourceProviderId) => {

  let data = Object?.values(filterChange)?.filter(el => el !== null)

  if (data?.length === 1) {
    for (const el in filterChange) {
      if (filterChange[el]) {
        base_url = `${base_url}${el}=${filterChange[el]}`
      }
    }
  }

  if (data?.length > 1) {
    for (const el in filterChange) {
      if (filterChange[el] !== "") {
        base_url = `${base_url}${el}=${filterChange[el]}&`
      }
    }
  }

  if (base_url?.endsWith("&")) {
    base_url = base_url.slice(0, base_url.length - 1)
  }

  if (resourceProviderId) {
    base_url = appendParam(
      base_url,
      "resource_provider",
      resourceProviderId
    );
  }
  return { base_url }
}
